export default __webpack_public_path__ + "static/media/2818958.cfe04b09.jpeg";